import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcTrainFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.701 4.48a2.75 2.75 0 0 1 2.7-2.23h7.197c.35 0 .687.066.998.187a.75.75 0 0 1 .686.389c.514.398.886.977 1.017 1.654L20.3 14.885a3.75 3.75 0 0 1-2.867 4.37l1.847 1.848a.75.75 0 1 1-1.06 1.06l-.593-.593H6.373l-.593.593a.75.75 0 0 1-1.06-1.06l1.847-1.848a3.75 3.75 0 0 1-2.867-4.37zm2.7-.73H15l-7.5 7.5H5.926l1.248-6.486A1.25 1.25 0 0 1 8.402 3.75m9.672 7.5-1.247-6.486a1.25 1.25 0 0 0-.218-.5L9.62 11.25zM8.28 19.663a.75.75 0 0 0 .19-.32h7.06a.75.75 0 0 0 .19.32l.407.407H7.873zm4.97-4.296a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }));
}
var IcTrainFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTrainFill));

export { IcTrainFill as I };
